export { default as useGetDiscountData } from './useGetDiscountData';
